import { Component, Vue } from 'vue-property-decorator';
import WithRender from './FlexiPayBalance.html';
import _axios from '@/services/axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { PriceList, ProductRow } from '@/types/ProductTypes';
import config from '@/settings/config';
import VuePhoneNumberInput from "vue-phone-number-input";
import { FlexiPayBalanceDto } from './FlexiPayBalanceDto';

@WithRender
@Component({
  filters:{
    formateDate(value: string)
    {
      return moment(value).format('YYYY-MM-DD')
    }
  },
  components: {
    Loading,
    VuePhoneNumberInput
  },
  computed: {
    ...mapGetters("originatorStore", {originator:"getOriginator",currency:"getWalletCurrency"}),
  }
})

export default class FlexiPayBalance extends Vue {
  priceList: PriceList = {} as PriceList;
  isLoading = false;

  form = {
    description:'',
    amount: '',
    receiverNumberwithCountryCode:'',
    senderNumberWithCountryCode:'',
    valideSenderNumberMessage:'',
    payerCountryCode:'',
    payerNumber:'',
    senderNumber:'',
    valideReceiverNumberMessage:'',
    receiverNumber:''
  }
  flexiPay = {} as FlexiPayBalanceDto;

  mounted() {
    this.getBalance();
  }

  async getBalance(): Promise<void> {
    try {
      const response = await _axios.get<FlexiPayBalanceDto>(`${config.gateway}credits/api/FlexiPay/GetBalance`);
      this.flexiPay = response.data;
    } catch (err) {
      console.error(err);
    }
  }

  async PayOut(payOutType:number):Promise<void>
  {
     let dto = {
      payOutType:payOutType
     }
     this.isLoading = true;  
     try{
       if(!this.validate())
       return;

       const prdt= await _axios.post(`${config.gateway}credits/api/FlexiPay/Payout`, dto);
       window.location.href = "/callback?msg=Pay out has been requested and being processed.";
    }
    catch (error)
    {
     this.ErrorNotifications(error);
    }
    finally
    {
      this.isLoading = false;
    }
  }

  private validate():boolean
  {
    if(this.flexiPay.balance <=0)
    {
      this.Notify("You have no funds to request for a payout");
      return false;
    }

    return true;
  }

  ErrorNotifications(obj:any) {
    let errorNotification = "";
    for (let prop in obj) {
      errorNotification += obj[prop].description + "\n";
    }
    this.Notify(errorNotification);
  }

  Notify(message: any) {
    this.$bvToast.toast(message, {
      title: "Notification",
      variant: "danger",
      autoHideDelay: 5000,
    });
  }
}
